export default __webpack_public_path__ + "static/media/cert-aroma.a6700e51.svg";